var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5 p-st",class:{ 'bg-white': !_vm.nightMode, 'bg-dark': _vm.nightMode }},[_c('navigation'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v("Contact")])])
}]

export { render, staticRenderFns }